<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                d="M3.0038 19.5461C3.18678 19.5788 3.3722 19.6045 3.55928 19.6227C3.78663 19.6449 4.01715 19.6562 4.25 19.6562C5.6201 19.6562 6.90049 19.2636 7.98246 18.5847C8.78844 18.7744 9.63208 18.875 10.5 18.875C16.0438 18.875 20.6562 14.7403 20.6562 9.5C20.6562 4.25973 16.0438 0.125 10.5 0.125C4.95624 0.125 0.34375 4.25973 0.34375 9.5C0.34375 12.0089 1.41104 14.2783 3.12886 15.9504C3.37053 16.1856 3.41779 16.3955 3.39398 16.5155C3.26307 17.1755 2.96549 17.7762 2.54538 18.272C2.36475 18.4852 2.31174 18.7786 2.40634 19.0416C2.50094 19.3045 2.72875 19.4969 3.0038 19.5461ZM6.59375 8.32812C5.94654 8.32812 5.42188 8.85279 5.42188 9.5C5.42188 10.1472 5.94654 10.6719 6.59375 10.6719C7.24096 10.6719 7.76562 10.1472 7.76562 9.5C7.76562 8.85279 7.24096 8.32812 6.59375 8.32812ZM9.32812 9.5C9.32812 8.85279 9.85279 8.32812 10.5 8.32812C11.1472 8.32812 11.6719 8.85279 11.6719 9.5C11.6719 10.1472 11.1472 10.6719 10.5 10.6719C9.85279 10.6719 9.32812 10.1472 9.32812 9.5ZM14.4062 8.32812C13.759 8.32812 13.2344 8.85279 13.2344 9.5C13.2344 10.1472 13.759 10.6719 14.4062 10.6719C15.0535 10.6719 15.5781 10.1472 15.5781 9.5C15.5781 8.85279 15.0535 8.32812 14.4062 8.32812Z"
                :fill="color" 
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgBubble',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>